// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop_scrollToTop__N+AGe"};